import React from 'react';
import { set, get } from 'lodash';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { checkCurrency, checkIsNumber, roundOff, roundingOff, shortenStringWithTooltip } from '../../../../../../Components/helper';
import useDetailedPageHook from '../../Hooks/useDetailedPageHook';
import useValidationHooks from '../../../../ProductCosting/Hooks/useValidationHooks';
import useShowHideSectionHooks from '../../Hooks/useShowHideSectionHooks';
import { averageCostingFieldpath, errorpath } from '../../../../ProductCosting/fieldPath';

export function AverageCostingExpandView(props) {
  const { expandData, index, isReadonly, expandAverageCostingChild, isExpanded, colourway, sizeRange, lengthRange, productInfoObj } = props;
  const { t } = useTranslation('common');
  const { productCostingstate, setProductCostingState, globalError } = productInfoObj;
  const {
    productInfo: { currency },
    isGlobalUrl,
    isBreakdown,
  } = productCostingstate;
  const { averageCosting } = globalError;
  const {
    ProductCostingData: { productCostingPreviousData },
    UserDetails: { isSupplierLoggedIn },
    BOMConfigDetails: { isProductArchived },
  } = useSelector((reduxState) => reduxState);

  const { calculateAvrageCosting } = useDetailedPageHook(productInfoObj);

  const { statusState, isDisabled, controlAmberColour, hideLengthCol } = useShowHideSectionHooks(productInfoObj);

  const { onChangeCheckIfErrorExist } = useValidationHooks();
  const handleInputChange = async (value, path, supplierPath) => {
    const copyState = productCostingstate;
    set(copyState, path, value);

    if (supplierPath) {
      if (isSupplierLoggedIn || isGlobalUrl) {
        const oldData = productCostingPreviousData;
        const previousValue = get(oldData, path);
        if (previousValue !== value) {
          set(copyState, supplierPath, true);
        } else set(copyState, supplierPath, false);
      }
    }

    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
    calculateAvrageCosting(copyState);
  };

  const updateError = (path) => onChangeCheckIfErrorExist(path, globalError);

  return expandData?.map((data, chindex) => {
    return (
      <tr key={index}>
        {chindex === 0 && !isBreakdown && expandData?.length !== 1 ? (
          <td>
            {isExpanded ? (
              <button
                className="btn-up-down"
                aria-label={t('COMMON_LABEL.OPEN')}
                type="button"
                onClick={() => {
                  expandAverageCostingChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon icon-inverse" />
              </button>
            ) : (
              <button
                className="btn-up-down"
                type="button"
                aria-label={t('COMMON_LABEL.CLOSE')}
                onClick={() => {
                  expandAverageCostingChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon" />
              </button>
            )}
          </td>
        ) : (
          <td />
        )}
        <td>{colourway?.name}</td>
        <td>{isBreakdown ? Array.isArray(sizeRange) && shortenStringWithTooltip(sizeRange?.map((e) => e?.name).join(' - '), 15) : data?.size || ''}</td>

        {hideLengthCol && (
          <td>
            {isBreakdown ? Array.isArray(lengthRange) && shortenStringWithTooltip(lengthRange?.map((e) => e?.name).join(' - '), 15) : data?.length?.name || ''}
          </td>
        )}
        <td className="text-right">
          {isDisabled || isReadonly ? (
            roundOff(data?.quantityPerSizCol, 4, true)
          ) : (
            <>
              <div className="d-flex align-items-center">
                <div className="flex-fill">
                  <input
                    onChange={(e) => {
                      if (checkIsNumber(e.target.value)) {
                        handleInputChange(e.target.value, averageCostingFieldpath(index, chindex).EXPAND_QUANTITY_PER_SIZ_COL);
                      }
                      if (get(averageCosting, `[${index}][${chindex}].quantityPerSizCol`, '')) {
                        updateError(errorpath(index, chindex).AVERAGE.ERROR_QUANTITY);
                      }
                    }}
                    readOnly={isDisabled}
                    value={data.quantityPerSizCol}
                    className="form-control text-bordered text-right"
                    type="text"
                  />
                </div>{' '}
              </div>
              <span className="error-message">{get(averageCosting, `[${index}][${chindex}].quantityPerSizCol`, '')}</span>
            </>
          )}
        </td>
        <td className="text-right">
          {isReadonly || isProductArchived || statusState ? (
            roundOff(data?.pricePerUnit, 4, true)
          ) : (
            <>
              <div className="d-flex align-items-center">
                <div className="flex-fill">
                  <input
                    onChange={(e) => {
                      if (checkIsNumber(e.target.value)) {
                        handleInputChange(
                          e.target.value,
                          averageCostingFieldpath(index, chindex).EXPAND_PRICE_PER_UNIT,
                          averageCostingFieldpath(index, chindex).IS_CHANGED_BY_SUPPLIER_PRICE_PER_UNIT,
                        );
                      }
                      if (get(averageCosting, `[${index}][${chindex}].pricePerUnit`, '')) {
                        updateError(errorpath(index, chindex).AVERAGE.ERROR_PRICE_PER_UNIT);
                      }
                    }}
                    className={
                      data.isChangedBySupllierPricePerUnit && controlAmberColour
                        ? 'suggested-data form-control text-bordered text-right'
                        : 'form-control text-bordered text-right'
                    }
                    value={data.pricePerUnit}
                    type="text"
                  />
                </div>{' '}
              </div>
              <span className="error-message">{get(averageCosting, `[${index}][${chindex}].pricePerUnit`, '')}</span>
            </>
          )}
        </td>
        <td className="text-right">
          {checkCurrency(currency, data?.totalPrice)} {isReadonly ? roundingOff(data?.totalPrice, 2, true) : roundingOff(data?.totalPrice, 4, true)}
        </td>
      </tr>
    );
  });
}

export default AverageCostingExpandView;
